export default __webpack_public_path__ + "static/media/landing.ilustration3.06ce549f.webp";